import { getYear, subYears } from 'date-fns';
import { moneyFormat } from 'design-system';
import { boolean, number, object, ObjectSchema, string } from 'yup';
import getMaxYear from '../../../../functions/getMaxYear';
import PricingProfileResponse from '../../../../models/responseTypes/PricingProfileResponse';

const reqError = 'El campo de valor del vehículo es obligatorio';
const currentDate = Date.now();

export const getMaxInsuredValue = (currency: string): number => {
  return currency === '$' ? 100_000 : 52_000_000;
};

export const onlyNumberAndLetter = (text: string): boolean => {
  const regex = /^[a-zA-Z0-9]*$/;
  return regex.test(text);
};

/**
 * Returns an instance of the required validation schema
 */
export default function makeValidationSchema(
  currentProfile: PricingProfileResponse,
): ObjectSchema {
  const maxYear = getMaxYear();
  const minYear =
    currentProfile.typeOfCoverage === 'CC'
      ? getYear(subYears(currentDate, 15))
      : getYear(subYears(currentDate, 20));
  const minYearQuantity = currentProfile.typeOfCoverage === 'CC' ? 15 : 20;
  const coverageTypeName =
    currentProfile.typeOfCoverage === 'DT'
      ? 'Daños a terceros'
      : 'Cobertura completa';
  const maxInsuredValue = getMaxInsuredValue(currentProfile.typeOfMoney);

  return object().shape({
    carBrand: string().required('La marca del auto es obligatoria'),
    carModel: string().required('El modelo del auto es obligatorio'),
    use: string().required('El uso del auto es obligatorio'),
    carYear: number()
      .required('El año del auto es obligatorio')
      .min(
        minYear,
        `Lamentablemente para vehículos con antiguedad mayor a ${minYearQuantity} años no puede asegurarse bajo ${coverageTypeName}`,
      )
      .max(maxYear, `El año del auto no puede ser mayor a ${maxYear}`)
      .typeError(
        `El año del auto es obligatorio, debe ser númerico y no puede ser mayor a ${maxYear}`,
      ),
    carValue: number()
      .typeError(reqError)
      .required(reqError)
      .min(
        1,
        `El valor no puede ser menor a ${moneyFormat.formatMoney(
          1,
          false,
          currentProfile.typeOfMoney,
        )}`,
      )
      .test(
        'max-test',
        `El valor excede el monto máximo de ${moneyFormat.formatMoney(
          maxInsuredValue,
          false,
          currentProfile.typeOfMoney,
        )}`,
        (value: number): boolean => value <= maxInsuredValue,
      ),
    isNewCar: boolean().when(
      'carYear',
      (carYear: string, schema: ObjectSchema) => {
        const year = parseInt(carYear, 10);
        if (year >= getYear(currentDate) - 1 && year <= maxYear) {
          return schema.required(
            'Es obligatorio seleccionar si es un auto 0 kilómetros',
          );
        }
        return schema.notRequired();
      },
    ),
    passengersQty:
      currentProfile.type === 'colectiva'
        ? string().required('Selecciona una cantidad de pasajeros')
        : string().notRequired(),
  });
}
